// extracted by mini-css-extract-plugin
module.exports = {"component":"HeaderSubNav_component__lxhLt"};